import React from 'react';
import styled from 'styled-components';
import { minBp } from 'src/lib/theme';

export const Wrap = styled.div`
  height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  padding: 30px 30px 0;

  @media ${minBp('tabletLarge')} {
    padding: 60px 50px 0;
    align-items: center;
  }
`;

export const Heading = styled.h1`
  font-size: 2.5rem;

  @media ${minBp('tabletLarge')} {
    max-width: 66.6%;
    font-size: 5rem;
    text-align: center;
  }
`;

export const GoBack = styled.a`
  &,
  &:focus,
  &:hover,
  &:active {
    font-family: ${({ theme }) => theme.fonts.dinDemi};
    text-transform: uppercase;
    font-size: 1rem;
    color: #000;
    text-decoration: none;

    svg {
      vertical-align: middle;
      width: 1rem;
      height: 1rem;
      position: relative;
      bottom: 2px;
      transition: transform 0.2s linear;
      transform: translateX(0);
    }
  }

  &:hover {
    svg {
      transform: translateX(-15px);
    }
  }

  @media ${minBp('tabletLarge')} {
    &,
    &:focus,
    &:hover,
    &:active {
      font-size: 2rem;

      svg {
        width: 28px;
        height: 28px;
        bottom: 3px;
      }
    }
  }
`;
